
import writer from "@/api/writer";
import log from "@/util/log";
import { WriterSetting } from "@/bluetooth/BluetoothData";

export default {
  name: "History",
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      error: false,
      historyList: [],
      pageNum: 1,
    };
  },
  created() {},
  async mounted() {},
  computed: {},
  methods: {
    onClickHeaderReturn() {
      this.$router.go(-1);
    },
    onClickApply(item) {
      const setting = new WriterSetting();
      Object.assign(setting, item);
      setting.diyVoltage = [].concat(item.diyVoltage.map((item) => item * -1));
      this.$router.replace({
        name: "Home",
        params: {
          setting,
        },
      });
    },
    async onRefresh() {
      this.refreshing = true;
      this.onLoad();
    },
    async onLoad() {
      //如果是刷新
      if (this.refreshing) {
        this.pageNum = 1;
        this.historyList = [];
      }
      try {
        let response = await writer.curveHistory(this.pageNum);
        const history = response.data;
        const total = response.total;
        // log(history);
        this.historyList = this.historyList.concat(
          history.map((item) => {
            const setting = new WriterSetting();
            setting.id = item.id;
            setting.diyVoltage = item.heatingVoltage
              .split(",")
              .slice(0, 6)
              .map((item) => parseInt(item));
            setting.isSupportNfc = item.nfcSettings === 1;
            setting.isSupportPreheat = item.preheatSetting === 1;
            setting.modeName = item.modeName;
            setting.preheatTime = item.preheatTime;
            setting.preheatVoltage = item.preheatVoltage;
            setting.createTime = item.createTime;
            return setting;
          })
        );

        //刷新结束
        if (this.refreshing) {
          this.refreshing = false;
        } else {
          this.loading = false;
        }
        if (this.historyList.length >= total) {
          this.finished = true;
        }
        this.pageNum += 1;
      } catch (e) {
        this.loading = false;
        this.error = true;
      }
    },
  },
};
